import { Box, Stack, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { MailSendLineIcon, MapPinLine, PhoneFillIcon } from '~/assets/icons';
import images from '~/assets/images/index';
import logoFioTec from '~/assets/images/logo-fiotec2.jpg';
import { BASE_COLORS } from '~/utils/constants/common';
import styles from './auth.module.scss';
import { ReactNode } from 'react';
const cx = classNames.bind(styles);

type Props = {
  children: ReactNode;
};

const AuthLayout = (props: Props) => {
  const { t } = useTranslation(['admin/auth']);
  return (
    <Box className={cx('w-full', 'h-full', 'flex', 'justify-center', 'items-center', 'auth-layout')}>
      <Box className={cx('flex-grow h-full relative', 'auth-left')}>
        <Box className='absolute top-[50%]'>
          <img
            src={logoFioTec}
            className={cx('shadow-[0px_3px_41.5px_0px_#FFFFFF] rounded-[50px] border border-white', 'fiotec-logo')}
            alt='logo'
          />
          <Typography
            className='w-[408px] 
             text-white font-bold 
             text-[40px] leading-[42px] 
             mt-[35px]'
            style={{ fontSize: '50px', lineHeight: '42px' }}
          >
            FIOTEC<br></br>
            <span style={{ fontSize: '40px' }}>Global Alert System</span>
          </Typography>
          <Typography
            className='w-[329px] h-[40px] text-white 
             text-[14px] leading-[20px] 
             mt-10 overflow-hidden whitespace-pre-line'
          >
            {`${t('login.description')}`}
          </Typography>
        </Box>
      </Box>
      <Box className={cx('px-[99px] py-[73px] flex flex-col justify-between h-full', 'auth-right')}>
        <Box>
          {/* Logo */}
          <Box className='flex justify-center '>
            <img src={images.fiotecLogoFinal} className={cx('fiotec-logo-final')} alt='Logo' />
          </Box>
          {props.children}
        </Box>
        <Box mt={3}>
          <Typography className='font-bold text-[#000000] text-[13px] h-[18px] mb-5'>
            {t('login.companyName')}
          </Typography>
          <Stack direction='row' gap={2} alignItems='center'>
            <PhoneFillIcon fill='#ED1002' />
            <Typography className={`text-[${BASE_COLORS.BLUE_BOLD}] text-[13px] w-[75px] h-[18px]`}>
              {t('login.phone')}
            </Typography>
          </Stack>
          <Stack direction='row' gap={2} alignItems='center'>
            <MailSendLineIcon fill='#ED1002' />
            <Typography className={`text-[${BASE_COLORS.BLUE_BOLD}]  text-[13px] w-[265px] h-[18px]`}>
              {t('login.email')}
            </Typography>
          </Stack>
          <Stack direction='row' gap={2} alignItems='start'>
            <MapPinLine className='w-[40px] h-[40px]' fill='#ED1002' />
            <Typography className={`text-[${BASE_COLORS.BLUE_BOLD}] text-[13px]`}>{`${t('login.address')}`}</Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
